import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    margin: ${rem(20)} 0;
  
    @media (min-width: ${breakpoints.md}px) {
        padding: ${rem(10)} ${rem(25)};
        border: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
        border-radius: ${rem(16)};
    }
`;

export const Section = styled.div`
    &:not(:last-child) {
        border-bottom: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
    }
    padding: ${rem(20)} 0;
`;

export const Title = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    display: block;
    padding-bottom: ${rem(5)};
    margin-bottom: ${rem(10)};
`;

export const HarmonogramPartTitle = styled.span`
    padding: ${rem(10)} 0;
    display: block;
`;

export const HarmonogramDay = styled.div`
    display: flex;
    flex-direction: column;
    margin: ${rem(15)} 0 0 0;
`;

export const HarmonogramDayDescription = styled.div`
    p {
        margin: ${rem(4)} 0;
    }
`;

export const HarmonogramDayTime = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    min-width: ${rem(150)};
    display: inline-block;
`;

export const Benefits = styled.div`
    a {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

export const Benefit = styled.div`
    padding-top: ${rem(10)};
    display: flex;
`;

export const BenefitIcon = styled(IconTemplate)`
    svg {
        width: ${rem(15)};
        height: ${rem(15)};

        path {
            fill: ${({ theme }) => theme.colors.green};
        }
    }

    margin-right: ${rem(10)};
    margin-top: ${rem(5)};
`;

export const BenefitLabel = styled.span``;

export const Materials = styled.div``;

export const Material = styled.div`
    padding-top: ${rem(10)};
    display: flex;
    cursor: pointer;
`;

export const MaterialIcon = styled(IconTemplate)`
    svg {
        width: ${rem(19)};
        height: ${rem(19)};
    }

    margin-right: ${rem(10)};
`;

export const MaterialLabel = styled.span`
    color: ${({ theme }) => theme.colors.primary};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
`;
